import React, { Component } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import Graph from "./Graph";
import { loadDashboardGraphDetails } from "../../Containers/Dashboard/actions";
import { dashbaordFrequencies, dateFormats } from "../../utility/enums";
import Session from "../../utility/session";
import { numberWithCommas } from "../../utility/commonHelpers";
const mapStateToProps = (state) => ({
  graphInfo: state.dashboardInfo.graphInfo,
});

const liStyle = {
  listStyleType: "none",
  fontWeight: "bold",
  cursor: "pointer",
  float: "left",
  borderColor: "#ccc",
  border: "1px",
};
let activeClass = dashbaordFrequencies.WEEK;

class DashboardGraph extends Component {
  constructor(props) {
    super(props);
    activeClass = dashbaordFrequencies.WEEK;
    this.selectDateRange = this.selectDateRange.bind(this);
  }

  selectDateRange(frequency) {
    let startDate = moment().subtract(6, "days").format('YYYY-MM-DD'),
      endDate = moment()
        .endOf("day")
        .format('YYYY-MM-DD')
    if (frequency == dashbaordFrequencies.TODAY) {
      startDate = moment()
        .startOf("day")
        .format('YYYY-MM-DD')
      activeClass = dashbaordFrequencies.TODAY;
    } else if (frequency == dashbaordFrequencies.WEEK) {
      startDate = moment()
        .subtract(6, "days")
        .format('YYYY-MM-DD')
      activeClass = dashbaordFrequencies.WEEK;
    } else if (frequency == dashbaordFrequencies.MONTH) {
      startDate = moment()
        .subtract(1, "month")
        .add(1, "day")
        .format('YYYY-MM-DD')
      activeClass = dashbaordFrequencies.MONTH;
    } else if (frequency == dashbaordFrequencies.THREEMONTHS) {
      startDate = moment()
        .subtract(3, "month")
        .add(1, "day")
        .format('YYYY-MM-DD')
      activeClass = dashbaordFrequencies.THREEMONTHS;
    }

    console.log("startdate is  " + startDate);
    console.log("enddate is  " + endDate);

    this.props.dispatch(
      loadDashboardGraphDetails({
        fromDate: startDate,
        toDate: endDate,
        username: Session.getItem(Session.CURRENT_USER_NAME),
        frequency: frequency,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
    );
  }

  componentDidMount() {
    this.props.dispatch(
      loadDashboardGraphDetails({
        fromDate: moment()
          .subtract(6, "days")
          .format('YYYY-MM-DD'),
        toDate: moment().format('YYYY-MM-DD'),
        username: Session.getItem(Session.CURRENT_USER_NAME),
        frequency: dashbaordFrequencies.WEEK,
        timeZone: Intl.DateTimeFormat().resolvedOptions().timeZone
      })
    );
  }

  render() {
    const {
      fromDate,
      toDate,
      totalEmails,
      totalEmailsPercent,
      goodEmails,
      goodEmailsPercent,
      badEmails,
      badEmailsPercent,
      unknownEmails,
      unknownEmailsPercent,
      totalDuplicates,
      totalSyntaxError,
      unknownScoredEmails,
      unknownScoredEmailsPercent,
      syntaxErrorPercent,
      duplicatesPercent,
      nonProcessed,
      nonProcessedPercent,
    } = this.props.graphInfo;

    return (
      <div className="row">
        <div className="col-md-12">
          <div className="x_panel">
            <div className="x_title">
              <h2 class="float-left">Verification Activity</h2>
              <div></div>
                {" "}
                {/* className="filter" */}
                <div>
                  {/* <i className="glyphicon glyphicon-calendar fa fa-calendar" />
                  <span>
                    {formDate} - {toDate}
                  </span>
                  <b className="caret" /> */}
                  <ul className="list-group" style={{ float: "right" }}>
                    <li style={liStyle}>
                      {/* <a onClick=  onClick={() => {
                          this.selectDateRange("1D");
                        }}> 1D</a> */}
                      {/* <span> &nbsp;&nbsp;</span> */}
                      {/* <button
                        onClick={() => {
                          this.selectDateRange("1D");
                        }}
                      >
                        1D
                      </button> */}

                      <a
                        className={
                          "list-group-item list-group-item-action " +
                          (activeClass == dashbaordFrequencies.TODAY
                            ? "active"
                            : "")
                        }
                        onClick={() => {
                          this.selectDateRange(dashbaordFrequencies.TODAY);
                        }}
                      >
                        Today
                      </a>
                    </li>
                    <li style={liStyle}>
                      {/* <span> &nbsp;&nbsp;</span> */}
                      <a
                        className={
                          "list-group-item list-group-item-action " +
                          (activeClass == dashbaordFrequencies.WEEK
                            ? "active"
                            : "")
                        }
                        onClick={() => {
                          this.selectDateRange(dashbaordFrequencies.WEEK);
                        }}
                      >
                        {" "}
                        Last 7 Days
                      </a>
                    </li>
                    <li style={liStyle}>
                      {/* <span> &nbsp;&nbsp;</span> */}
                      <a
                        className={
                          "list-group-item list-group-item-action " +
                          (activeClass == dashbaordFrequencies.MONTH
                            ? "active"
                            : "")
                        }
                        onClick={() => {
                          this.selectDateRange(dashbaordFrequencies.MONTH);
                        }}
                      >
                        {" "}
                        Last Month
                      </a>
                    </li>
                    <li style={liStyle}>
                      {/* <span> &nbsp;&nbsp;</span> */}
                      <a
                        className={
                          "list-group-item list-group-item-action " +
                          (activeClass == dashbaordFrequencies.THREEMONTHS
                            ? "active"
                            : "")
                        }
                        onClick={() => {
                          this.selectDateRange(
                            dashbaordFrequencies.THREEMONTHS
                          );
                        }}
                      >
                        {" "}
                        Last 3 Months
                      </a>
                    </li>

                    {/* <li style={liStyle} onClick={this.selectDateRange("7D")}>
                      <a>7D</a>
                      <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </li>
                    <li style={liStyle} onClick={this.selectDateRange("1M")}>
                      <a>1M</a>
                      <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </li>
                    <li style={liStyle} onClick={this.selectDateRange("12M")}>
                      <a>12M</a>
                      <span> &nbsp;&nbsp;&nbsp;&nbsp;</span>
                    </li> */}
                  </ul>

                  {/* <DateRangePicker
                    startDate={
                      fromDate
                        ? moment(fromDate)
                        : new moment().subtract(6, "days")
                    }
                    endDate={toDate ? moment(toDate) : new moment()}
                    onApply={this._handleApply}
                    showDropdowns
                    className="pull-right"
                    style={{
                      background: "#fff",
                      cursor: "pointer",
                      padding: "5px 10px",
                      border: "1px solid #ccc"
                    }}
                  >
                    <button>
                      <span>
                        {fromDate} - {toDate}
                      </span>&nbsp;
                      <i className="glyphicon glyphicon-calendar fa fa-calendar" />
                      <span /> <b className="caret" />
                    </button>
                  </DateRangePicker> */}
                </div>
          
              <div className="clearfix" />
            </div>

            <div className="x_content">
              <div className="col-md-12 col-sm-12 col-xs-12 no-padding">
                <div className="demo-container">
                  {/* <div id="chart_plot_01" className="demo-placeholder" /> */}
                  <Graph />
                </div>
                <div className="tiles">
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(totalEmails)}</strong>
                    </h2>
                    <div className="progress progress_sm">
                      {/* <div
                        className="progress-bar bg-blue"
                        role="progressbar"
                        data-transitiongoal="99"
                        style={{ width: totalEmailsPercent + "%" }}
                      /> */}
                      <div
                        className="progress-bar bg-green"
                        role="progressbar"
                        data-transitiongoal="70"
                        style={{ width: goodEmailsPercent + "%" }}
                      />
                      <div
                        className="progress-bar bg-red"
                        role="progressbar"
                        data-transitiongoal="20"
                        style={{ width: badEmailsPercent + "%" }}
                      />
                      <div
                        className="progress-bar bg-darkUnknownScored"
                        role="progressbar"
                        data-transitiongoal="10"
                        style={{ width: unknownScoredEmailsPercent + "%" }}
                      />
                      <div
                        className="progress-bar bg-dark"
                        role="progressbar"
                        data-transitiongoal="10"
                        style={{ width: unknownEmailsPercent + "%" }}
                      />
                      <div
                        className="progress-bar bg-light-green"
                        role="progressbar"
                        data-transitiongoal="99"
                        style={{ width: syntaxErrorPercent + "%" }}
                      />
                      <div
                        className="progress-bar bg-blue"
                        role="progressbar"
                        data-transitiongoal="99"
                        style={{ width: duplicatesPercent + "%" }}
                      />
                    </div>
                    <span>Total Emails</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(goodEmails)}</strong>
                      <small>({goodEmailsPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-green"
                        role="progressbar"
                        data-transitiongoal="70"
                        style={{ width: goodEmailsPercent + "%" }}
                      />
                    </div>
                    <span>Valid</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(badEmails)}</strong>
                      <small>({badEmailsPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-red"
                        role="progressbar"
                        data-transitiongoal="20"
                        style={{ width: badEmailsPercent + "%" }}
                      />
                    </div>
                    <span>Invalid</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(unknownScoredEmails)}</strong>
                      <small>({unknownScoredEmailsPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-darkUnknownScored"
                        role="progressbar"
                        data-transitiongoal="10"
                        style={{ width: unknownScoredEmailsPercent + "%" }}
                      />
                    </div>
                    <span>Unknown Scored</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(unknownEmails)}</strong>
                      <small>({unknownEmailsPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-dark"
                        role="progressbar"
                        data-transitiongoal="10"
                        style={{ width: unknownEmailsPercent + "%" }}
                      />
                    </div>
                    <span>Unknown</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(totalSyntaxError)}</strong>
                      <small>({syntaxErrorPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-light-green"
                        role="progressbar"
                        data-transitiongoal="99"
                        style={{ width: syntaxErrorPercent + "%" }}
                      />
                    </div>
                    <span>Invalid Email Format</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(totalDuplicates)}</strong>
                      <small>({duplicatesPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-blue"
                        role="progressbar"
                        data-transitiongoal="99"
                        style={{ width: duplicatesPercent + "%" }}
                      />
                    </div>
                    <span>Duplicates</span>
                  </div>
                  <div className="col-md-2 tile">
                    <h2>
                      <strong>{numberWithCommas(nonProcessed)}</strong>
                      <small>({nonProcessedPercent}%)</small>
                    </h2>
                    <div className="progress progress_sm">
                      <div
                        className="progress-bar bg-soft-orange"
                        role="progressbar"
                        data-transitiongoal="99"
                        style={{ width: duplicatesPercent + "%" }}
                      />
                    </div>
                    <span>Not Verified</span>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

DashboardGraph.propTypes = {
  formDate: PropTypes.string,
  toDate: PropTypes.string,
  totalEmails: PropTypes.string,
  totalEmailsPercent: PropTypes.string,
  goodEmails: PropTypes.string,
  goodEmailsPercent: PropTypes.string,
  badEmails: PropTypes.string,
  badEmailsPercent: PropTypes.string,
  unknownEmails: PropTypes.string,
  unknownEmailsPercent: PropTypes.string,
};

export default connect(mapStateToProps)(DashboardGraph);



// WEBPACK FOOTER //
// ./src/components/Dashboard/DashboardGraph.js